import React, { useEffect, useRef, useState } from 'react'
import { Container, Spinner } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import EditDeliveryMethodView from './Includes/EditDeliveryMethodView'
import FeatherIcon from 'feather-icons-react';
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import { toast } from 'react-toastify'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import { cancelGetShippingDetailsApi, editShipping, getShippingDetails } from 'utlis/Apis/Shipping_API'
import { useFormik } from 'formik'
import { ERROR_WHILE_GETTING_SHIPPING_DETAILS } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE_UPDATING_SHIPPING } from 'utlis/AppMessages/AppMessages'
import { SHIPPING_UPDATED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages'
import { getError } from 'utlis/AppMessages/AppMessages'
import { conditionalShippingParams_, customRateShippingParams_, conditionalShippingParams, customRateShippingParams, flatRateShippingParams, freeShippingParams, deleteExtra } from '../Shippings/Includes/Shipping/AddShipping/Helper'
import { freeShippingIv, freeShippinVS_ } from './Helper'
import { getCustomerCountries } from 'utlis/Apis/Customers_API'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'

function EditDeliveryMethod(props) {
    // props
    const { authState } = props

    const submitButtonRef = useRef(null)
    const [loading, setLoading] = useState(true)
    const [shipping, setShipping] = useState({})
    const [submitButtonDisable, setSubmitButtonDisable] = useState(false)
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false)
    const [countries, setCountries] = useState({})

    // store url
    const [storeUrl] = useStoreUrl()

    const setFormData = (shippingData) => {
        setShipping(shippingData)
    }
    useEffect(() => {
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        // getShippings(headers).then(res => {
        //     setLoading(false)
        //     const resData = res.data
        //     window.scrollTo(0, 0)
        //     if (resData && resData.success) {
        //         setShipping(resData.data)
        //     }
        //     if (resData && resData.error) {
        //         toast.dismiss();

        //         toast.error(ERROR_WHILE_FETCHING_SHIPPINGS, {
        //             autoClose: 3000
        //         })
        //     }
        // }).catch(err => {
        //     console.log(`${ERROR_WHILE__NAME} getShippings `, err.message)

        //     toast.dismiss();
        //     toast.error(UNKNOWN_ERROR_OCCURED, {
        //         autoClose: 2500,
        //         onClose: () => {
        //             setLoading(false)
        //         }
        //     })
        // })
        getShipping__()

        getCustomerCountries(headers).then(res => {
            const countriesData = res.data
            if (countriesData.success) {
                setCountries(countriesData.data)
            }
            if (countriesData.error) {
                console.log('Error occured while loading countries groups!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCountries `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
        // }
    }, [props.match.params.id, props.location.state, authState])

    const getShipping__ = () => {
        const id = props.match.params.id ?? ""
        setLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getShippingDetails(headers, id).then(res => {
            setLoading(false)
            const shippingData = res.data
            if (shippingData.success) {
                const shippings_ = shippingData.data[0] || {}

                console.log("shippings_ ", shippingData);

                let params = {}
                if (shippings_?.shipping_type === "free_shipping") {
                    params = freeShippingParams(shippings_)
                } else if (shippings_?.shipping_type === "conditional_free_shipping") {
                    params = conditionalShippingParams_(shippings_)
                } else if (shippings_?.shipping_type === "flat_rate") {
                    params = flatRateShippingParams(shippings_)
                } else {
                    params = customRateShippingParams_(shippings_)
                }
                setFormData(params)
            }
            if (shippingData.error) {
                console.log(ERROR_WHILE_GETTING_SHIPPING_DETAILS, res)
                toast.dismiss();
                toast.error(getError(shippingData.message, ERROR_WHILE_GETTING_SHIPPING_DETAILS), {
                    autoClose: 3000,
                })
            }
        }).catch(shippingData => {
            console.log(`${getError(shippingData.message)} getShippingDetails `)
            toast.dismiss();
            toast.error(getError(shippingData.message), {
                autoClose: 2500
            })
        })
        return () => {
            cancelGetShippingDetailsApi()
        }

    }

    const onEditFormSubmit = values => {
        if (values) {
            const list = []
            values.shippingrates = values.shippingrates || []
            values.shippingrates.forEach(e => {
                if (!e.range_from) { list.push("a") }
                else if (e.add && !e.range_to) { list.push("a") }
                else if (e.add && parseFloat(e.range_from) >= parseFloat(e.range_to)) { list.push("a") }
                else if (!e.amount) { list.push("a") }
                else if (e.rate_based_on === "full" && !e.rate_per_item) { list.push("a") }
                else if (e.rate_based_on === "full" && !e.rate_percent_charge) { list.push("a") }
                else if (e.rate_based_on === "full" && !e.rate_per_lbs) { list.push("a") }
            })
            if ((values.shipping_type === "conditional_free_shipping" || values.shipping_type === "custom_rates") && list.length > 0) {
                toast.dismiss();
                toast.error("Please fill the required fields")
                return
            }
            // else if (values.shipping_type === "conditional_free_shipping" || values.shipping_type === "custom_rates") {
            //     values.range_from = []
            //     values.range_to = []
            //     values.rate_per_item = []
            //     values.rate_percent_charge = []
            //     values.rate_per_lbs = []

            //     values.shippingrates.forEach(e => {
            //         values.range_from.push(e.range_from || 0)
            //         values.range_to.push(e.range_to || 0)
            //         values.rate_per_item.push(e.rate_per_item || 0)
            //         if (values.rate_based_on === "full") {
            //             values.rate_percent_charge.push(e.rate_percent_charge || 0)
            //             values.rate_per_lbs.push(e.rate_per_lbs || 0)
            //         }
            //     })
            // }

            setGlobalLoading(true)
            setGlobalLoading(true)
            setSubmitButtonDisable(true)
            setSubmitButtonLoading(true)

            let params = {}
            if (values.shipping_type === "free_shipping") {
                params = freeShippingParams(values)
            } else if (values.shipping_type === "conditional_free_shipping") {
                params = conditionalShippingParams({
                    ...values,
                    amount: values?.shippingrates?.map(item => item.amount)
                })
            } else if (values.shipping_type === "flat_rate") {
                params = flatRateShippingParams(values)
            } else {
                params = customRateShippingParams({
                    ...values,
                    amount: values?.shippingrates?.map(item => item.amount)
                })
                console.log("gello ", {
                    ...values,
                    amount: values?.shippingrates?.map(item => item.amount)
                });
            }
            params = deleteExtra(params)
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            editShipping(headers, params).then(res => {
                setGlobalLoading(false)
                setGlobalLoading(false)
                setSubmitButtonDisable(false)
                setSubmitButtonLoading(false)
                const addingShipping = res.data
                if (addingShipping.success) {
                    onSuccess(addingShipping.data)
                }
                if (addingShipping.error) {
                    onError(res)
                }
            }).catch(err => {
                setSubmitButtonLoading(false)
                console.log(`${ERROR_WHILE__NAME} updatingShipping `, err.message)
                onCatch()
            })
        }
    }
    const onError = (res) => {
        setSubmitButtonDisable(false)
        console.log(ERROR_WHILE_UPDATING_SHIPPING, res)
        toast.dismiss();
        toast.error(ERROR_WHILE_UPDATING_SHIPPING, {
            autoClose: 3000,
        })

    }
    const onCatch = () => {
        setSubmitButtonLoading(true)
        toast.dismiss();
        toast.error(UNKNOWN_ERROR_OCCURED, {
            autoClose: 2500,
            onClose: () => {
                setSubmitButtonLoading(false)
                setSubmitButtonDisable(false)
                setGlobalLoading(false)
            }
        })
    }
    const onSuccess = () => {
        getShipping__()
        setSubmitButtonLoading(true)
        window.scrollTo(0, 0)
        toast.dismiss();
        setSubmitButtonLoading(false)
        toast.success(SHIPPING_UPDATED_SUCCESSFULLY, {
            autoClose: 2000,
            onClose: () => { }
        })
    }
    const formik = useFormik({
        initialValues: freeShippingIv(shipping),
        validate: freeShippinVS_,
        onSubmit: onEditFormSubmit,
        enableReinitialize: true
    })

    const handleFormSubmission = (ev) => {
        ev.preventDefault()
        window.scrollTo(0, 0)
        submitButtonRef.current.click()
    }

    return (
        <section id="app-shipping" className="st-def-mar-B page-eorc-wrapper">
            <form
                onSubmit={formik.handleSubmit}
                noValidate
                autoComplete="off">
                <div id="page-save-button-block" className={"component-changed"}>
                    <Container fluid className="st-container">
                        <div className="page-save-button-block d-flex align-items-center">
                            <div className="back-button-wrapper st-line-height-0">
                                <Link to={storeUrl + "/settings/shippings"}
                                    className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-14 st-fw-600">
                                    <FeatherIcon
                                        icon="arrow-left"
                                        size="16"
                                        className="icon me-1" />
                                    <span>Back</span>
                                </Link>
                            </div>

                            {/* save btn */}
                            <button
                                type="button"
                                className={`st-btn st-btn-primary ms-auto  ${submitButtonDisable ? "disabled" : ""}`}
                                disabled={submitButtonDisable}//|| Object.keys(formik.errors).length}
                                onClick={handleFormSubmission}>
                                {
                                    submitButtonLoading ? (
                                        <Spinner animation="border" size="sm" />
                                    ) : (
                                        <span>Save</span>
                                    )
                                }
                            </button>
                        </div>
                    </Container>
                </div>
                <Container fluid className="st-container">
                    <div className="app-product-filters">
                        <EditDeliveryMethodView
                            setFormData={setFormData}
                            loading={loading}
                            shipping={shipping}
                            setShipping={setShipping}
                            formik={formik}
                            countries={countries}
                        />
                    </div>
                </Container>
                <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
            </form>
        </section>
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditDeliveryMethod)